export enum ThemeModeEnum {
  LIGHT = 'light',
  DARK = 'dark',
}
